import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  CreateContainer,
  DownloadRow,
  DownloadSection,
  DragDropContainer,
  GoBackContainer,
  ProceedButtonContainer,
  Row,
  TitleContainer
} from './style';
import MainFont from '../../typography/mainFont';
import { Button, Checkbox, Icon } from 'ui/atoms';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import theme from '../../theme';
import {
  BULK_LEAD_CREATION,
  DOWNLOAD_LEAD_SAMPLE
} from 'redux/sagas/actions/lead';
import { DragDrop } from '../index';
import { getBase64Format } from '../../../api/helpers/people';
import { AcceptButtonContainer } from '../CreateAccount/style';
import { SpinnerIcon } from '../../atoms/Table/style';
import spinnerIconWhite from '../../assets/img/spinner-icon-white.png';

const CreateLeadCSV = ({
  resetLeadType,
  downloadSampleCsv,
  uploadCSV,
  isLoadingCreationBulk
}) => {
  const { t } = useTranslation();
  const [errorDragDrop, setErrorDragDrop] = useState(true);
  const [selectedFile, setSelectedFile] = useState();
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  const onSubmitFile = e => {
    e.preventDefault();
    getBase64Format(selectedFile, result => {
      uploadCSV({ file: result, name: selectedFile?.name });
    });
  };

  return (
    <CreateContainer>
      <TitleContainer>
        <GoBackContainer>
          <Icon
            type="icon-back"
            size="20"
            color={theme().colors.aquamarine}
            onClick={resetLeadType}
          />
        </GoBackContainer>
        <MainFont type="createAccountHeaders">{t('lead_csv')} </MainFont>
      </TitleContainer>
      <MainFont type="leadCsvUpload">
        {t('lead_import_csv_text')}\
        <MainFont type="resumeLabel">{t('max_lead')}</MainFont>
      </MainFont>
      <DownloadRow>
        <DownloadSection onClick={() => downloadSampleCsv({ leadType: 'B2C' })}>
          <Icon
            type="icon-download1"
            color={theme().colors.mainBlue}
            size={14}
          />
          <MainFont>{t('download_sample_lead_b2c_csv')}</MainFont>
        </DownloadSection>
        <DownloadSection onClick={() => downloadSampleCsv({ leadType: 'B2B' })}>
          <Icon
            type="icon-download1"
            color={theme().colors.mainBlue}
            size={14}
          />
          <MainFont>{t('download_sample_lead_b2b_csv')}</MainFont>
        </DownloadSection>
      </DownloadRow>
      <DragDropContainer>
        <form onSubmit={onSubmitFile}>
          <DragDrop
            handleError={setErrorDragDrop}
            setSelectedFile={setSelectedFile}
            selectedFile={selectedFile}
            validExtensions={['application/vnd.ms-excel', 'text/csv']}
            maxSize={1024 ** 2}
            titleType="createAccountHeaders"
            height={293}
          />
          <Row
            clickable
            onClick={() => {
              setPrivacyAccepted(!privacyAccepted);
            }}
          >
            <Checkbox checked={privacyAccepted} />

            <MainFont>{t('confirm_lead_csv')}</MainFont>
          </Row>
          {isLoadingCreationBulk ? (
            <AcceptButtonContainer id="button-container">
              <Button variant="accept-button" noPadding>
                <SpinnerIcon icon={spinnerIconWhite} marginRight={11} />
                <MainFont type="addAccountLabels">{t('loading')}</MainFont>
              </Button>
            </AcceptButtonContainer>
          ) : (
            <ProceedButtonContainer>
              <Button
                type="submit"
                variant="accept-button"
                disabled={errorDragDrop || !privacyAccepted}
              >
                <MainFont type="addAccountLabels"> {t('proceed')} </MainFont>
              </Button>
            </ProceedButtonContainer>
          )}
        </form>
      </DragDropContainer>
    </CreateContainer>
  );
};

CreateLeadCSV.propTypes = {
  resetLeadType: PropTypes.func,
  downloadSampleCsv: PropTypes.func,
  uploadCSV: PropTypes.func,
  isLoadingCreationBulk: PropTypes.bool
};

export default connect(
  state => ({ isLoadingCreationBulk: state?.lead?.isLoadingCreationBulk }),
  dispatch => ({
    downloadSampleCsv: payload =>
      dispatch({ type: DOWNLOAD_LEAD_SAMPLE._REQUEST, payload }),
    uploadCSV: payload =>
      dispatch({ type: BULK_LEAD_CREATION._REQUEST, payload })
  })
)(CreateLeadCSV);
